import { makeAutoObservable } from "mobx";
import { IDrone, ISimpleResponce } from "@drone-parts.garphild.pro/interfaces";
import ordersStorage from "./orders.storage";
import RestApiQuery, { ApiEndpoints } from "../helpers/rest-api-query";
import { notification } from "antd";

class DronesStorage {
  drones: IDrone[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  loadDrones = async () => {
    try {
      const response = await RestApiQuery.get<ISimpleResponce<IDrone[]>>(ApiEndpoints.Drones, { pageSize: '1000'})
      this.drones = response?.data || [];
    } catch (error: any) {
      notification.error({ message: error.message });
    }
  }

}

const dronesStorage = new DronesStorage();

export default dronesStorage;
